<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        CONVERSATION TOPIC
      </h1>
      <button class="create-button" @click="onOpenForm(null)">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        :empty-text="$t('noData')"
        :current-page="filter.pageNo"
        :per-page="filter.perPage"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(toggle)="data">
          <font-awesome-icon
            v-if="data.item.groupId"
            :icon="data.item._showDetails ? 'minus-square' : 'plus-square'"
            class="icon-toggle"
            @click="toggleDetails(data.item)"
          />
        </template>
        <template #row-details="row">
          <div class="p-2">
            <b-table
              small
              :items="row.item.topics"
              :fields="fieldsSub"
              responsive
              bordered
              class="mb-0"
            >
              <template v-slot:cell(isActive)="data">
                <span
                  :class="data.item.isActive ? 'text-success' : 'text-danger'"
                >
                  <toggle-button
                    :ref="`toggle-${data.item.id}`"
                    class="mt-1 mr-1 mb-0"
                    :value="data.item.isActive"
                    :color="{
                      checked: '#27BDA7',
                      unchecked: '#B0B0B0',
                    }"
                    @change="handleChangeStatus(data.item)"
                  />
                </span>
              </template>
            </b-table>
          </div>
        </template>
        <template v-slot:cell(isActive)="data">
          <toggle-button
            :ref="`toggle-${data.item.id}`"
            class="mt-1 mr-1 mb-0"
            :value="data.item.isActive"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
            @change="handleChangeStatus(data.item)"
          />
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onOpenForm(data.item)">
              <font-awesome-icon
                icon="pencil-alt"
                class="text-warning"
                title="Edit"
              />
            </b-link>
            <!-- <b-link class="text-link ml-3" @click="onDeleteModal(data.item)">
              <font-awesome-icon
                icon="trash-alt"
                class="text-danger"
                title="Delete"
              />
            </b-link> -->
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to
            {{ endPage | numeral("0,0") }} of
            {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <ModalCreateOrEdit
      ref="modalCreateOrEdit"
      @reloadData="reloadData"
      :topicGroupEnable="brandDetail.topicGroupEnable"
    />
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCreateOrEdit from "./component/ModalCreateOrEdit.vue";

export default {
  name: "Variable",
  components: {
    ModalAlertConfirm,
    ModalCreateOrEdit,
  },
  data: function () {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        id: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      fields: [
        {
          key: "toggle",
          label: "",
          class: "text-center",
        },
        {
          key: "name",
          label: "Name",
          class: "text-center",
        },
        {
          key: "isActive",
          label: "Status",
          class: "mw-150px",
        },
        {
          key: "sortOrder",
          label: "Sort Order",
          class: "mw-150px",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      fieldsSub: [
        {
          key: "name",
          label: "Name",
          class: "text-center",
        },
        {
          key: "isActive",
          label: "Status",
          class: "mw-150px",
        },
        {
          key: "sortOrder",
          label: "Sort Order",
          class: "mw-150px",
        },
      ],
      items: [],
      filter: {
        pageNo: 1,
        perPage: 10,
      },
    };
  },
  created: async function () {
    await this.getList();
  },
  computed: {
    brandDetail() {
      return this.$store.getters.getBrandDetail();
    },
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .get(`${this.$baseUrl}/FlowBuilder/Topics?isDeleted=0`)
        .then((data) => {
          if (data.result == 1 && data.detail) {
            const existTopicsGroup = data.detail.filter(
              (item) => item.groupId !== 0
            );
            let tempItems = [];
            if (existTopicsGroup && existTopicsGroup.length > 0) {
              existTopicsGroup.forEach((item) => {
                const { topics } = item;
                const topic = {
                  id: item.groupId,
                  name: item.groupName,
                  isActive: item.groupIsActive,
                  sortOrder: item.groupSortOrder,
                  groupId: item.groupId,
                  topics,
                };

                tempItems.push(topic);
              });
            }

            const existTopics = data.detail.findIndex(
              (item) => item.groupId === 0
            );

            if (existTopics !== -1) {
              const { topics } = data.detail[existTopics];

              tempItems.push(...topics);
            }
            this.$set(this, "items", tempItems);
            this.rows = this.items.length;
          }
        });
      this.isBusy = false;
    },
    onOpenForm(item = null) {
      this.$refs.modalCreateOrEdit.show(item);
    },
    onDeleteModal(data) {
      this.bodyDelete.id = data.id;
      this.modalMsgDelete = `${this.$t('confirmDelete2')} ${data.name} ${this.$t('yesOrNo')}`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/FlowBuilder/Topics/${this.bodyDelete.id}`)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            this.reloadData();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    async reloadData() {
      this.$refs.modalCreateOrEdit.hide();
      await this.getList();
    },
    async pagination(Page) {
      this.filter.pageNo = Page;
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      this.isBusy = true;
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
      this.isBusy = false;
    },

    async updateIsActive(topicId, topicGroupId, isActive) {
      const response = await this.axios.patch(
        `${this.$baseUrl}/FlowBuilder/topics/status`,
        null,
        {
          params: {
            topicId,
            topicGroupId,
            isActive,
          },
        }
      );
      return response;
    },

    async handleChangeStatus(item) {
      const isActive = !item.isActive;
      let topicGroupId = null;
      let topicId = null;

      const isTopicGroup = !!item.topics;

      if (isTopicGroup) {
        topicGroupId = item.id;
      } else {
        topicId = item.id;
      }
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      const response = await this.updateIsActive(
        topicId,
        topicGroupId,
        isActive
      );
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
      if (response.result !== 1) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: response.message,
        });
      } else {
        this.$store.commit("UPDATE_GLOBAL_ALERT", {
          isShow: true,
          msg: "",
        });
      }
    },
    toggleDetails(item) {
      if (item["_showDetails"]) item["_showDetails"] = false;
      else this.$set(item, "_showDetails", true);
    },
  },
};
</script>

<style>
.icon-toggle {
  cursor: pointer;
  color: #7160c4;
}
.hidden_header {
  display: none;
}
</style>
